<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { fetchDeliveries, saveDelivery, removeDelivery, searchDeliveries, subscribeToDeliveries, unsubscribeFromDeliveries } from '../controllers/deliveryController.js';
    import { fetchUsers } from '../controllers/userController.js'; // Función para cargar usuarios

    // Configuración de las columnas para la tabla de entregas
    let deliveryColumns = [
        { label: 'Nombre', field: 'nombre', type: 'text' },
        { label: 'Teléfono', field: 'telefono', type: 'text' },
        { label: 'Dirección', field: 'direccion', type: 'text' },
        { label: 'DPI', field: 'dpi', type: 'text' },
        { label: 'Matrícula', field: 'matricula', type: 'text' },
        { label: 'Estado', field: 'sta', type: 'bool' },
    ];

    // Estructura del nuevo objeto Delivery
    let newDelivery = {
        nombre: '',
        telefono: '',
        direccion: '',
        dpi: '',
        matricula: '',
        sta: true,
        user: '',
    };

    // Configuración de los campos para la edición de entregas
    let editColumns = [
        { label: 'Nombre', key: 'nombre', type: 'text', required: true },
        { label: 'Teléfono', key: 'telefono', type: 'text', required: true },
        { label: 'Dirección', key: 'direccion', type: 'text', required: true },
        { label: 'DPI', key: 'dpi', type: 'text', required: true },
        { label: 'Matrícula', key: 'matricula', type: 'text', required: true },
        { label: 'Estado', key: 'sta', type: 'checkbox', required: true },
        { label: 'Usuario', key: 'user', type: 'select', required: true, options: [] } // Options will be populated dynamically
    ];

    // Función para cargar y transformar usuarios
    async function loadUsers() {
        try {
            const fetchedUsers = await fetchUsers();

            if (Array.isArray(fetchedUsers.users)) {
                // Transformar los usuarios en el formato requerido
                const userOptions = fetchedUsers.users.map(user => ({
                    key: user.id,
                    value: user.email,
                }));

                // Actualizar las opciones del campo 'user' en editColumns
                editColumns = editColumns.map(column => {
                    if (column.key === 'user') {
                        return { ...column, options: userOptions };
                    }
                    return column;
                });
            } else {
                console.error('Se esperaba un array de usuarios, pero se obtuvo:', fetchedUsers);
            }
        } catch (error) {
            console.error('Error al cargar los usuarios:', error);
        }
    }

    // Cargar los usuarios al montar el componente
    onMount(() => {
        loadUsers();
    });
</script>

<CRUD 
    title="Repartidores"
    entityName="delivery"
    newEntity={newDelivery}
    columns={deliveryColumns}
    fetchEntities={fetchDeliveries}
    saveEntity={saveDelivery}
    removeEntity={removeDelivery}
    searchEntities={searchDeliveries}
    subscribeToChanges={subscribeToDeliveries}
    unsubscribeFromChanges={unsubscribeFromDeliveries}
    editColumns={editColumns}
/>